import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Contactform from "./Contactform";


export default function Contactus() {
    return (
        <>
            <div className="aboutus_bg">
                <div className="aboutus-img-content">
                    <h1>Contact Us</h1>

                </div>

            </div>
            <section className="py-5" style={{ backgroundColor: "#f8f9fa" }} >
                <Container>
                    {/* Section Title */}
                    <div className="text-center mb-5">
                        <h2 className="fw-bold">Contact Us</h2>
                        <p className="text-muted">
                            Interested in our IT services or need advice? Then please get in
                            touch and we’ll be glad to help.
                        </p>
                    </div>

                    {/* Contact Options */}
                    <Row className="g-4">
                        {/* FAQs */}
                        <Col md={4} className="text-center">
                            <div className="p-4 rounded shadow-sm" style={{ backgroundColor: "#fff",height:'100%' }}>

                                <h5 className="fw-bold">Contact</h5>
                                <p className="text-muted">
                                +974 51852341<br/> +974 66730852
                                </p>
                                <div className="mb-3 mt-4">
                                    <img
                                        src="images/chat.svg"
                                        alt="FAQs"
                                        style={{ width: "50px" }}
                                    />
                                </div>
                            </div>
                        </Col>

                        {/* Headquarters */}
                        <Col md={4} className="text-center">
                            <div className="p-4 rounded shadow-sm" style={{ backgroundColor: "#fff",height:'100%' }}>

                                <h5 className="fw-bold">Address</h5>
                                <p className="text-muted">
                                    Office No 51, 5th Floor, Al EZZ
                                    tower 4 , Street No 840, Zone
                                    18, Al Safiliya, Doha, Qatar.
                                </p>
                                <div className="mb-3 mt-4">
                                    <img
                                        src="images/location.svg"
                                        alt="Headquarters"
                                        style={{ width: "50px" }}
                                    />
                                </div>
                            </div>
                        </Col>

                        {/* Working Hours */}
                        <Col md={4} className="text-center">
                            <div className="p-4 rounded shadow-sm" style={{ backgroundColor: "#fff",height:'100%' }}>

                                <h5 className="fw-bold">Working Hours</h5>
                                <p className="text-muted">
                                    Open Monday to Saturday <br /> From 07:00 AM to 18:00 PM
                                </p>
                                <div className="mb-3 mt-4">
                                    <img
                                        src="images/time.svg"
                                        alt="Working Hours"
                                        style={{ width: "50px" }}
                                    />
                                </div>
                                {/* <a href="#help-center" className="text-info fw-bold">
                Help Center →
              </a> */}
                            </div>
                        </Col>
                    </Row>

                    {/* Footer */}
                    {/* <div className="text-center mt-4">
          <p className="text-muted">
            You can also email us at{" "}
            <a href="mailto:sales@example.com" className="text-info fw-bold">
              sales@example.com
            </a>
          </p>
        </div> */}
                </Container>
            </section>
            {/* <Contactform /> */}
        </>
    )
}